const MessageType = {
  text: "0",
  image: "1",
  file: "2",
  voice: "3",
  bot: "b",
  // assistant:'A',
};
export default MessageType;
